import { FC } from 'react'

import { PrimaryDottedButton } from '../Buttons/PrimaryDottedButton'

export const TimeSaveButton: FC = (props) => (
  <PrimaryDottedButton {...props}>Save</PrimaryDottedButton>
)
